import { useMemo } from 'react';
import { BlogCard } from '@/widgets/BlogCard';
import { blogArticlePath, blogPlainText, IBlogArticle, visibleBlogArticles } from '@/entities/Blog';
import { Loader } from '@/shared/ui/Loader';
import { Section } from '@/shared/ui/Section';

const HOME_BLOG_LIMIT = 3;

interface HomeBlogsProps {
  articles?: IBlogArticle[];
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
}

export const HomeBlogs = ({ articles, isLoading, isError, isSuccess }: HomeBlogsProps) => {
  const visible = useMemo(
    () => visibleBlogArticles(articles).slice(0, HOME_BLOG_LIMIT),
    [articles],
  );

  if (isError || (isSuccess && visible.length === 0)) return null;

  return (
    <Section typeSection="section">
      <h2 className="mb-6 text-[32px] font-medium">Blog</h2>
      {isLoading ? (
        <div className="grid min-h-[120px] place-items-center">
          <Loader />
        </div>
      ) : (
        <ul className="grid grid-cols-1 gap-4 tablet:grid-cols-2 desktop:grid-cols-3">
          {visible.map((article) => (
            <li key={article.id} className="min-w-0">
              <BlogCard
                title={article.title}
                href={blogArticlePath(article.slug)}
                excerpt={blogPlainText(article.text)}
                image={article.image}
              />
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
};
